export const data = {
  error: {
    color: "danger",
  },
  success: {
    color: "success",
  },
};
